import React from 'react';
import { NavLink } from 'react-router-dom';
// import { useNavigate } from 'react-router-dom';

// import { CgProfile } from "react-icons/cg";
// import { MdOutlineTextsms } from "react-icons/md";
// import { MdOutlineCampaign } from "react-icons/md";
// import { AiOutlineFileDone } from "react-icons/ai";
// import { TbListDetails } from "react-icons/tb";
// import { TbLogout } from "react-icons/tb";
// import { Link } from "react-router-dom";
import { LuLayoutDashboard } from "react-icons/lu";
import { PiLink } from "react-icons/pi";
import { RxCross2 } from "react-icons/rx";
import { BiRegistered } from 'react-icons/bi';
import { IoAnalyticsOutline } from 'react-icons/io5';


import logo from "../../assets/images/logo.png";



const sidebarNavItems = [
    {
        id: 1,
        icon: <LuLayoutDashboard />,
        heading: "Dashboard",
        link: "/dashboard"
    },
    {
        id: 2,
        icon: <BiRegistered />,
        heading: "Header Registration",
        link: "/headerRegistration"
    },
    {
        id: 3,
        icon: <IoAnalyticsOutline />,
        heading: "URL Analytics",
        link: "/urlAnalytics"
    },
    {
        id: 4,
        icon: <PiLink />,
        heading: "Manage URLs",
        link: "/manageUrl"
    },
    // {
    //     id: 2,
    //     icon: <CgProfile />,
    //     heading: "Subscriber Profiles",
    //     link: "/uploadProfile"
    // },
    // {
    //     id: 4,
    //     icon: <MdOutlineTextsms />,
    //     heading: "SMS Templates",
    //     link: "/createSms"
    // },
    // {
    //     id: 7,
    //     icon: <MdOutlineCampaign />,
    //     heading: "Today's Campaigns",
    //     link: "/todaysCampaign"
    // },
    // {
    //     id: 8,
    //     icon: <AiOutlineFileDone />,
    //     heading: "Executed Campaigns",
    //     link: "/executedCamp"
    // },
    // {
    //     id: 9,
    //     icon: <TbListDetails />,
    //     heading: "CDR",
    //     link: "/totalCDRs"
    // }
]

function Sidebar({ show, onClose }) {

    let sideBarList = (item, index) => {
        return (
            <NavLink
                to={item.link}
                activeclassname="active"
                className="menuItems"
                key={index}
            >
                <div className='menu_icon'>{item.icon}</div>
                <div className="menu_heading">{item.heading}</div>
            </NavLink>
        )
    }

    return (
        <>

            <div className={show ? 'sidebar active' : 'sidebar'}>
                <RxCross2 className="ms-auto icon-grey" id="cross" onClick={onClose} />
                <img src={logo} className='mb-3 mainlogo' alt="logo" />
                <div className='dash_options'>
                    {sidebarNavItems.map((item, index) => sideBarList(item, index))}
                </div>

                {/* <div className='bottom'>
                    <Link to='/' className='menuItems' activeclassname='active' onClick={() => { localStorage.clear() }}>
                        <div className='menu_icon'><TbLogout /></div>
                        <div className='menu_heading'>Logout</div>
                    </Link>
                </div> */}
            </div>
        </>
    );
}
export default Sidebar;